import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.a1{align-items:flex-end;}.ssr-plugin'
import '.a2{gap:1rem;}.ssr-plugin'
import '.a3{flex:1 0 0;}.ssr-plugin'
import '.a4{position:fixed;}.ssr-plugin'
import '.a8{z-index:12;}.ssr-plugin'
import { useState, useCallback, PropsWithChildren } from 'react'
import { type ToastType, Toast } from '@app/components/blocks/toast/Toast'
import useMediaQuery from '../useMediaQuery'
import { styled } from 'inlines'
import { useTranslations } from '@i18n/useLanguage'
import { ToastContext, ToastModel } from './ToastContext'
import { ClientOnly } from '@based/sdk/react'

export const ToastProvider = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const [activeToasts, setActiveToasts] = useState<ToastModel[]>([])
  const [isPaused, setIsPaused] = useState(false)
  const genericFailureMessage =
    useTranslations().app.common.genericToastFailureMessage

  const showToast = useCallback(
    (type: ToastType, message: string, hideAfterSeconds?: number) => {
      const id = Math.random().toString(36).substring(2, 9)
      const newToast = { id, message, type, hideAfterSeconds }
      setActiveToasts((prev) => [...prev, newToast])
    },
    [setActiveToasts],
  )

  const showSuccessToast = useCallback(
    (message: string, hideAfterSeconds?: number) => {
      showToast('success', message, hideAfterSeconds)
    },
    [showToast],
  )

  const showFailToast = useCallback(
    (message?: string, hideAfterSeconds?: number) => {
      showToast('error', message ?? genericFailureMessage, hideAfterSeconds)
    },
    [genericFailureMessage, showToast],
  )

  const closeToast = (id: string) => {
    setActiveToasts((prev) => prev.filter((t) => t.id !== id))
  }

  const value = { showToast, showSuccessToast, showFailToast }

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="a b a1 a2 a3 a4 a8"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        style={{
          right: isMobile ? '0.5rem' : '1.5rem',
          left: isMobile ? '0.5rem' : 'auto',
          top: isMobile ? '5rem' : '1.5rem',}}
      >
        <ClientOnly>
          {activeToasts.map((t, i) => (
            <Toast
              key={t.id}
              {...t}
              hideAfterSeconds={(t.hideAfterSeconds ?? 3) + 0.3 * i}
              isHideTimeoutPaused={isPaused}
              onRemove={() => closeToast(t.id)}
            />
          ))}
        </ClientOnly>
      </div>
    </ToastContext.Provider>
  )
}
